import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

const atlasProjectEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "@atlaskit-internal_@atlassian/entry-point-fixtures/ProjectPanel" */ './ProjectPanel'
			).then((mod) => mod.ProjectPanel),
		{
			moduleId: 'atlas-project-entrypoint',
		},
	),
	getPreloadProps: () => ({}),
});

export default atlasProjectEntryPoint;
